import { Functions, Dashboard as DashboardIcon, ViewCarousel, Widgets } from '@mui/icons-material';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type DashboardMobileNavigationValue = 'dashboard' | 'widgets' | 'variables' | 'dashboards';

interface Props {
  value: DashboardMobileNavigationValue;
  onDashboardAction: () => void;
  onWidgetsAction: () => void;
  onVariablesAction: () => void;
  onDashboardsAction: () => void;
}

export const DashboardMobileNavigation: FC<Props> = ({
  value,
  onDashboardAction,
  onWidgetsAction,
  onVariablesAction,
  onDashboardsAction,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={8}
      className="fixed inset-x-0 bottom-0 z-50 border-0 border-t border-solid border-gray-200 md:hidden"
      square
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(
          _event: React.SyntheticEvent,
          nextValue: DashboardMobileNavigationValue
        ): void => {
          if (nextValue === 'dashboard') {
            onDashboardAction();
            return;
          }

          if (nextValue === 'widgets') {
            onWidgetsAction();
            return;
          }

          if (nextValue === 'variables') {
            onVariablesAction();
            return;
          }

          onDashboardsAction();
        }}
      >
        <BottomNavigationAction
          value="dashboard"
          label={t('dashboard_fallback_dashboard', 'Dashboard')}
          icon={<DashboardIcon fontSize="small" />}
        />
        <BottomNavigationAction
          value="widgets"
          label={t('dashboard_widgets', 'Widgets')}
          icon={<Widgets fontSize="small" />}
        />
        <BottomNavigationAction
          value="variables"
          label={t('dashboard_variables', 'Variables')}
          icon={<Functions fontSize="small" />}
        />
        <BottomNavigationAction
          value="dashboards"
          label={t('dashboards_title', 'Dashboards')}
          icon={<ViewCarousel fontSize="small" />}
        />
      </BottomNavigation>
    </Paper>
  );
};
